<div class="ip-coverage-amount-container">
    <h5 class="h5">{{ coverageTitle | translate }}</h5>
    <div *ngFor="let coverage of medicalCoverages" class="ip-coverage-amount-item">
        <p [id]="networkFilter + '-family-' + coverage.coverage + '-coverage'" class="ip-coverage-amount-item-text body-regular">{{ coverage.coverage | translate }}</p>
        <p [id]="networkFilter + '-family-' + coverage.coverage + '-amount'" class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
    </div>
</div>
